<template>
    <div class="column">
        <h4 class="title is-4">DOT Permits</h4>
        <o-table
            class="is-responsive is-responsive-xs-desktop"
            :data="paginatedData"

            :bordered="table.bordered"
            :striped="table.striped"
            :narrowed="table.narrowed"
            :checkable="table.checkable"
            :mobile-cards="table.mobileCards"
            :paginated="table.paginated"
            :pagination-simple="table.paginationSimple"
            :per-page="table.perPage"
            :default-sort-direction="table.defaultSortDirection"
            :default-sort="table.defaultSort"

            :selected.sync="selected"
            :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"

            :loading="loading"
            :total="total"
            backend-sorting
            backend-pagination
            @page-change="onPageChange"
            @sort="onSort"
        >
            <template>
                <o-table-column #default="{ row }" field="permit_number" label="Permit #" sortable>
                    {{ row.permit_number }}
                </o-table-column>

                <o-table-column #default="{ row }" field="location_of_work" label="Location" sortable>
                    {{ row.location_of_work }}
                </o-table-column>

                <o-table-column #default="{ row }" field="applicant_id" label="Applicant" sortable>
                    {{ row.applicant_name }}
                </o-table-column>

                <o-table-column #default="{ row }" field="permit_type_id" label="Permit Type" sortable>
                    {{ permitTypeNameById(row.permit_type_id) }}
                </o-table-column>

                <o-table-column #default="{ row }" field="expiration_date" label="Expiration Date" sortable>
                    {{ $filters.valueOrDefault($filters.date(row.expiration_date)) }}
                </o-table-column>

                <o-table-column #default="{ row }" field="status" label="Status" sortable>
                    {{ statusNameById(row.status) }}
                </o-table-column>

                <o-table-column #default="{ row }" label="">
                    <o-dropdown hoverable position="bottom-left" class="table-actions">
                      <template #trigger>
                        <button class="button">
                          <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                        </button>
                      </template>
                        <o-dropdown-item has-link><a @click="openReminderModal(row.project_id, row.applicant_id)">Set Reminder</a></o-dropdown-item>
                    </o-dropdown>
                </o-table-column>
            </template>

          <template #empty>
            <div class="has-text-centered">
              No Tracking Expirations
            </div>
          </template>
        </o-table>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive" has-modal-card>
            <send-reminder-modal :project-id="projectId" :contact-id="contactId"/>
        </o-modal>
    </div>
</template>

<script>
    import SendReminderModal from '../modals/SendReminder'
    import { mapActions, mapGetters } from 'vuex'
    import Table from '../../mixins/Table'

    export default {
        mixins: [Table],

        components: {
            SendReminderModal
        },

        data () {
            return {
                table: {
                    defaultSort: ['expiration_date', 'asc']
                },
                moment: moment,
                projectId: null,
                contactId: null,
                isReminderModalActive: false
            }
        },

        mounted () {
            this.fetchPermitTypes().then(() => this.fetchPaginatedData())
        },

        methods: {
            ...mapActions({
                fetchData: 'dot-permits/fetch',
                fetchPermitTypes: 'fetchPermitTypes'
            }),

            openReminderModal (projectId, contactId) {
                this.isReminderModalActive = true
                this.projectId = projectId
                this.contactId = contactId
            },
        },

        computed: {
            ...mapGetters({
                projectNameById: 'projectNameById',
                itemsByIds: 'dot-permits/itemsByIds',
                permitTypeNameById: 'permitTypeNameById',
            })
        }
    }
</script>
